import React, {useState, useContext, useEffect} from 'react';
import {useQueryClient} from "react-query";
import __ from "lodash";
import moment from "moment";
import SystemContext from "../../../SystemContext";
import {useSettings} from "../../../services/settings";

import {useGetBooking} from "../../../services/booking";
import useCurrencies from "../../../services/currencies/useCurrencies";
import useExchangeRates from "../../../services/currencies/useExchangeRatesWithName";

import BookingForm from "./BookingForm";
import {prepareRecordForEditing} from "./BookingRecord";
import BookingQueueStyles from "../styles/BookingQueueStyles";
import { makeStyles } from '@material-ui/core';

const ViewBooking = (props) => {

  const classes = makeStyles(BookingQueueStyles)();

  const [viewBooking, setViewBooking] = useState ({
    open: false,
    bookingUuid: null,
  });
  let spotBookings = false;
  let specialLoads = false;

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  const queryClient = useQueryClient();
  let extraKeys = [viewBooking.bookingUuid];
  const booking = useGetBooking({queryClient, extraKeys});

  const rateExtraKeys = ["SYSTEM", moment().format("YYYY-MM-DD")];
  const currencies = useCurrencies(queryClient, []);
  const exchangeRates = useExchangeRates({queryClient, extraKeys: rateExtraKeys});
  const terms = useSettings({queryClient, extraKeys: ["TERMS"]});

  useEffect(() => {
    const handleOpenBooking = (params) => {
      setViewBooking({...params}); 
    }

    if (eventBus) {
      eventBus.bind('ViewBooking.open', handleOpenBooking);
      return () => {
        eventBus.unbind('ViewBooking.open', handleOpenBooking);
      }
    }
  }, [eventBus]);

  let bookingData = null;

  if (booking && Array.isArray(booking.data) && booking.data.length > 0) {
    bookingData = prepareRecordForEditing(booking.data[0], exchangeRates.data, currencies.data);
    if (bookingData) {
      if (bookingData.bookingType === 'SPOT') spotBookings = true;
      if (bookingData.bookingType === 'SPECIAL LOAD') specialLoads = true;
    }
  }


  return (bookingData && booking && Array.isArray(booking.data) && booking.data.length > 0 &&
    <div>
      {viewBooking.open ?
        <BookingForm
          record={bookingData}
          canEdit={false}
          newBooking={false}
          spotBooking={spotBookings}
          // formMode: GSA - for GSA bookings (does not require GSA selection), OPERATOR - for system operator bookings (requires GSA selection), SLR - for Special Load Requests
          formMode={specialLoads ? "SLR" : "OPERATOR"}
          captureParticipants={spotBookings || !bookingData.forwarderCompanyUuid ? false : true}
          close={()=>{setViewBooking({open: false, rowData: null})}}
          classes={classes}
          exchangeRates={exchangeRates.data}
          currencies={currencies}
          terms={terms.data}
          dialogStates={{showDialog: viewBooking.open, awb: bookingData.awbNo, gsaCompanyUuid: bookingData.gsaCompanyUuid}}
        />
        : <></>
      }
    </div>
  );

}

export default ViewBooking;
